<template>
  <div class="invoice-details-progress">
    <div class="progress-con" v-if="invoiceDetail && invoiceDetail.length > 0">
      <div class="progress-header">
        <div class="progress-title">
          <div v-if="invoiceStatus===3">我们将尽快开具，为您发送至{{ invoiceDetail[0].gmfMobile ? '手机号' : '邮箱' }}</div>
          <div v-if="invoiceStatus===2">开票失败</div>
          <div v-if="invoiceStatus===1">发票已发送至{{ invoiceDetail[0].gmfMobile ? '手机号' : '邮箱' }}</div>
        </div>
        <div class="progress-detail">
          <div class="detail-title">进度</div>
          <div class="detail-detail-con">
            <div class="detail-image" :style="{'width': invoiceStatus===3 ? '305px' : '592px'}">
              <img v-if="invoiceStatus===3" src="https://resource.rcclchina.com.cn/invoice/invoicing_v1.0.png" alt="">
              <img v-if="invoiceStatus===1"  src="https://resource.rcclchina.com.cn/invoice/invoice-complete.png" alt="">
              <img v-if="invoiceStatus===2"  src="https://resource.rcclchina.com.cn/invoice/invoicing-error.png" alt="">
            </div>
            <div class="detail-date" v-if="invoiceDetail && invoiceDetail.length > 0" :style="{'width': invoiceStatus===3 ? '493px' : '780px'}">
              <div class="detail-date-item">
                <div>用户申请开票</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].createdTime,0)}}</div>
              </div>
              <div class="detail-date-item" :class="invoiceStatus===3 ? 'active' :''">
                <div>发票开具中</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].createdTime,0)}}</div>
              </div>
              <div class="detail-date-item" v-if="invoiceStatus===1" :class="invoiceStatus===1 ? 'active' :''">
                <div>开票成功</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].kprq)}}</div>
              </div>
              <div class="detail-date-item" v-if="invoiceStatus===2" style="color: #fe0000">
                <div>发票开具失败</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="progress-main">
        <div class="detail-title">开票明细</div>
        <div class="invoice-info">
          <div class="info-item" v-for="(i,idx) in invoiceDetail" :key="idx">
            <div class="item-left">
              <div class="invoice-index">发票{{idx+1}}</div>
              <div>发票抬头</div>
              <div>
                <div class="company-name">{{ i.gmfMc }}</div>
                <div v-if="i.gmfNsrsbh" class="company-nsrsh">税号&nbsp;&nbsp; {{i.gmfNsrsbh}}</div>
              </div>
            </div>
            <div class="item-right">
              发票金额<div class="item-right-price">￥{{i.amount}}</div>
            </div>
          </div>
        </div>
        <div class="invoice-detail" v-if="invoiceDetail && invoiceDetail.length > 0">
          <div class="invoice-type" v-if="invoiceDetail[0].gmfMobile">
            <div class="invoice-type-left">
              手机号
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceDetail[0].gmfMobile}}
              </div>
            </div>
          </div>
          <div class="invoice-type" v-else>
            <div class="invoice-type-left">
              邮箱地址
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceDetail[0].gmfEmail}}
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              发票类型
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                增值税普通发票（电子发票）
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              开票方
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{ invoiceCompany }}
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              发票内容
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceContent}}
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-footer">
          <div v-if="invoiceStatus!==2" style="display: flex;align-items: center;gap: 50px">
            <div v-if="invoiceStatus===1">
            <div class="resendBtn" @click="rebillingSubmit" v-if="isReopenInvoice">
            重开发票
            </div>
            <div class="resendBtn" style="background: #f5f5f5;color: #c4c4c4" v-if="!isReopenInvoice">
              重开发票
            </div>
            </div>
            <div v-if="invoiceStatus==3" class="resendBtn gray">
              重新发送
            </div>
            <div v-else class="resendBtn" @click="resendSubmit">
              重新发送
            </div>
          </div>
          <div v-else>
            <div class="resendBtn" @click="rebillingSubmit">
            开发票
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noData" v-else>
      暂无开票记录
    </div>
    <div class="invoice-tips-con" v-if="isShowInvoiceTips">
      <div class="invoice-reissued-tips">
        <div class="invoice-reissued-tips-title">温馨提示</div>
        <div class="invoice-reissued-tips-content">
          <div>重开发票会作废历史已开具发票</div>
        </div>
        <div class="tips-btn">
          <div class="btn-left" @click="rebillingSubmit">取消</div>
          <div class="btn-right" @click="confirmAnewInvoice">确认</div>
        </div>
      </div>
    </div>
    <InvoicePopup popupTitle="填写接收信息"
                  v-if="isShowReceiveInfo"
                  @closePopup="isShowReceiveInfo=false">
      <div class="addInvoice-form">
        <div class="addInvoice-item">
          <div class="addInvoice-item-title">选择方式</div>
          <div class="addInvoice-item-content">
            <div class="">
              <label class="invoice-radio" for="addInvoice-enterprise">
                <input type="radio" v-model="receiveType" :value="1" id="addInvoice-enterprise">邮箱
              </label>
            </div>
            <div>
              <label class="invoice-radio" for="addInvoice-noEnterprise">
                <input type="radio" v-model="receiveType" :value="2" id="addInvoice-noEnterprise">手机号
              </label>
            </div>
          </div>
        </div>
        <div class="addInvoice-item" v-if="receiveType===1">
          <div class="addInvoice-item-title">邮箱地址</div>
          <div class="addInvoice-item-content">
            <input type="text" v-model="receiveInfoValue" placeholder="邮箱地址为必填">
          </div>
        </div>
        <div class="addInvoice-item"  v-if="receiveType===2">
          <div class="addInvoice-item-title">手机号</div>
          <div class="addInvoice-item-content">
            <input type="text" v-model="receiveInfoValue" placeholder="手机号为必填">
          </div>
        </div>
        <div class="receiveInfo-tips">
          <div v-if="verifyReceiveFormMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{verifyReceiveFormMsg}}</div>
        </div>
        <div class="addInvoiceBtn" @click="saveReceiveInfo">提交</div>
      </div>
    </InvoicePopup>
  </div>
</template>
<script>
import api from "@/api";
import InvoicePopup from "@/components/Alert/InvoicePopup.vue";
import {isEmpty} from '@/utilities/tools'

export default {
  components: {InvoicePopup},
  data () {
    return {
      invoiceApplyId:'',
      invoiceDetail:null,
      isInvoiceCompleted:'',
      isShowInvoiceTips:false,
      isShowReceiveInfo:false,
      receiveInfoValue:'',
      receiveType:1,
      verifyReceiveFormMsg:'',
      invoiceStatus:'',
      isReopenInvoice:false,
      bookingRecordIds:'',
      invoiceCompany:'开票方为皇家加勒比游轮船务（中国）有限公司',
      invoiceContent:'旅游服务*代订住宿费',
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage(){
      let query = this.$route.query
      this.invoiceApplyId = query.invoiceApplyId
      this.getInvoiceInfo()
    },
    async getInvoiceInfo() {
      let params = {
        invoiceApplyId: this.invoiceApplyId,
        userName:this.$store.state.user.userToken
      }
      this.$loading.show()
      let {success, data, errMsg} = await api.booking.getBookingRecordInvoice(params)
      this.$loading.hide()
      if(success){
        if(data.invoiceApplyOrderList && data.invoiceApplyOrderList.length > 0){
          this.invoiceStatus = data.status
          this.isReopenInvoice = data.isReopenInvoice
          data.invoiceApplyOrderList.forEach(item=>{
            if(item.amount%1 === 0){
              item.amount = item.amount+'.00'
            }
          })
          let bookingRecordIds = []
          // bookingRecord_Id需要改为加密encBookingRecordId
          data.invoiceApplyBookingDetailViewModel.forEach(item=>{
            bookingRecordIds.push(item.encBookingRecordId)
          })
          this.bookingRecordIds = bookingRecordIds.join(',')
        }
        this.invoiceDetail = data.invoiceApplyOrderList
        this.invoiceCompany = data.xsfMc
        this.invoiceContent = data.invoiceContent
      }else{
        this.$alert.show(errMsg);
      }
    },
    formatDateString(dateString, addHours = 0) {
      if(isEmpty(dateString)) return "";
      const date = new Date(dateString);
      date.setHours(date.getHours() + addHours);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}月${day}日${hours}:${minutes}`;
    },
    resendSubmit() {
      this.isShowReceiveInfo = true
    },
    async saveReceiveInfo() {
      // 验证邮箱
      this.verifyReceiveFormMsg = ''
      if (this.receiveType === 1) {
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (this.receiveInfoValue.trim() === '') {
          this.verifyReceiveFormMsg = '请填写邮箱地址'
        } else {
          if (!reg.test(this.receiveInfoValue)) {
            this.verifyReceiveFormMsg = '请填写正确的邮箱地址'
          }
        }
      } else {  // 验证手机号
        let reg = /^1[3456789]\d{9}$/
        if (this.receiveInfoValue.trim() === '') {
          this.verifyReceiveFormMsg = '请填写手机号'
        } else {
          if (!reg.test(this.receiveInfoValue)) {
            this.verifyReceiveFormMsg = '请填写正确的手机号'
          }
        }
      }
      if (this.verifyReceiveFormMsg !== '') return
      this.isShowReceiveInfo = false
      let params = {
        InvoiceApplyId: this.invoiceDetail[0].invoiceApplyId,
        Mobile:this.receiveType===2 ? this.receiveInfoValue : '',
        Email:this.receiveType===1 ? this.receiveInfoValue : '',
      }
      this.$loading.show()
      let {success, errMsg} = await api.booking.resendInvoice(params)
      this.$loading.hide()
      if (success) {
        this.$alert.show('重新发送成功')
        setTimeout(()=>{
          this.isShowReceiveInfo = false
        },1500)
      } else {
        this.$alert.show(errMsg);
      }
    },
    rebillingSubmit(){
      this.isShowInvoiceTips = !this.isShowInvoiceTips
    },
    confirmAnewInvoice(){
      this.$router.push({
          path:'/Rccl.Booking/Booking/InvoiceDetails',
          query:{
            bookingRecordIds:this.bookingRecordIds,
            invoiceApplyId:this.invoiceDetail[0].invoiceApplyId
          }
      })
    }
  },
}
</script>
<style lang="less" scoped>
.invoice-details-progress{
  background-color: #f5f5f5;
  position: relative;
  padding-bottom: 27px;
  .progress-con{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 24px;
    .progress-header{
      height: 248px;
      background-color: #fff;
      margin: 0 auto 10px;
      .progress-title{
        width: 1200px;
        height: 83px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 180px;
        font-size: 20px;
        color: #ffffff;
        background: linear-gradient(to left, #00aeea, #006ab6);
      }
      .progress-detail{
        padding: 25px 0;
        width: 840px;
        margin: 0 auto;
        .detail-title{
          color: #333333;
          font-size: 17px;
          font-weight: bold;
        }
        .detail-detail-con{
          margin: 16px auto 0;
          .detail-image{
            width: 592px;
            height: 18px;
            margin: 0 auto;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .detail-date{
            width: 780px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            font-size: 16px;
            color: #202020;
            margin: 11px auto 0;
            .detail-date-item{
              width: 200px;
              font-size: 16px;
              color: #202020;
              .progress-date{
                font-size: 13px;
              }
            }
            .detail-date-item.active{
              color: #fcc300;
              font-weight: bold;
            }
          }
        }
      }
    }
    .progress-main{
      width: 1200px;
      background-color: #fff;
      box-sizing: border-box;
      padding-bottom: 27px;
      .detail-title{
        width: 840px;
        margin: 0 auto;
        color: #333333;
        font-size: 17px;
        font-weight: bold;
        padding: 27px 0 18px;
      }
      .invoice-info{
        width: 840px;
        margin: 0 auto;
        .info-item{
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          //justify-content: space-between;
          background-color: #f6f6f6;
          border-radius: 8px;
          padding: 0 37px 0 22px;
          font-size: 16px;
          color: #202020;
          margin-bottom: 7px;
          cursor: pointer;
          .item-left{
            display: flex;
            align-items: center;
            gap: 38px;
            .invoice-index{
              padding: 9px 22px;
              border-radius: 6px;
              color: #fff;
              background-color: #fcc300;
            }
            .company-name{
              width: 330px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-weight: bold;
              margin-right: 40px;
            }
            .company-nsrsh{
              font-size: 13px;
              color: #999;
            }
          }
          .item-right{
            display: flex;
            align-items: center;
            gap: 30px;
            .item-right-price{
              color: #1c6ab6;
              font-size: 16px;
            }
          }
        }
      }
      .invoice-detail{
        padding-left: 22px;
        .invoice-type:last-child{
          border-bottom: none;
        }
        .invoice-type {
          width: 840px;
          display: flex;
          font-size: 16px;
          border-bottom: 1px #dde3e5 dashed;
          padding: 20px 0;
          margin: 0 auto;
          .invoice-type-left {
            color: #999999;
            width: 240px;
            text-align: left;
          }
          .invoice-type-right {
            color: #202020;
            cursor: pointer;
            .right-tips {
              padding-left: 27px;
              font-size: 13px;
              color: #999999;
            }
          }
        }
      }
      .invoice-footer{
        display: flex;
        align-items: center;
        gap: 52px;
        justify-content: center;
        .resendBtn{
          width: 370px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          border-radius: 3px;
          background: linear-gradient(to right, #fcbf00, #ffdb17);
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin: 35px 0;
          cursor: pointer;
        }
        .gray{
          background: #e9e9e9;
          color: #a7a7a7;
        }
      }
    }
  }
  .invoice-tips-con{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background:  rgba(0,0,0,0.7);
    .invoice-reissued-tips{
      width: 800px;
      height: 277px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background-color: #fff;
      text-align: center;
      .invoice-reissued-tips-title{
        width: 100%;
        line-height: 80px;
        font-size: 26px;
        font-weight: bold;
        color: #fcc300;
        border-bottom: 1px solid #d9d9d9;
      }
      .invoice-reissued-tips-content{
        width: 100%;
        padding: 42px 0;
        font-size: 22px;
        color: #202020;
      }
      .tips-btn{
        width: 100%;
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 55px;
        div{
          width: 264px;
          height: 50px;
          line-height: 50px;
          border-radius: 3px;
          cursor: pointer;
        }
        .btn-left{
          background-color: #ececec;
        }
        .btn-right{
          background: linear-gradient(to right, #fcbf00, #ffdb17);
        }
      }
    }
  }
}

.addInvoice-form {
  padding: 15px 180px 0;
  position: relative;

  .addInvoice-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    position: relative;

    .addInvoice-item-title {
      width: 126px;
      font-size: 16px;
      color: #202020;
      text-align: left;
      position: relative;

      img {
        width: 17px;
        height: 17px;
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .addInvoice-item-content {
      width: 351px;
      //justify-content: space-between;
      display: flex;
      align-items: center;
      position: relative;
      gap: 46px;

      .companySelect {
        position: absolute;
        top: 31px;
        left: 0;
        width: 100%;
        z-index: 9;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        box-sizing: border-box;
        max-height: 300px;
        overflow-y: auto;
        font-size: 14px;
        background-color: #f5f5f5;
        padding: 8px 15px;
        //隐藏滚动条
        &::-webkit-scrollbar {
          display: none;
        }

        .companySelect-item {
          padding: 4px 0;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-bottom: 1px solid #dcdcdc;

          .companySelect-item-title {
            color: #202020;
          }

          .companySelect-item-nsrsbh {
            color: #999999;
            font-size: 13px;
          }
        }
      }

      input[type="text"] {
        width: 100%;
        height: 31px;
        border: 1px solid #bfbfbf;
        border-radius: 6px;
        font-style: normal;
        font-size: 13px;
        padding-left: 17px;
      }
    }

    .invoiceTypePopup {
      width: 549px;
      height: auto;
      position: absolute;
      top: 40px;
      background-color: rgba(32, 32, 32, 0.7);
      color: #ffffff;
      font-size: 18px;
      border-radius: 20px;
      padding: 17px 30px;
      z-index: 9;

      .nsrsbh-con {
        .nsrsbh-type {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .nsrsbh-con-item {
          position: relative;
          padding-left: 10px;
        }
      }

      .tips-dot {
        position: absolute;
        top: 13px;
        left: 0;
        transform: translate(-50%, -50%);
        display: block;
        width: 5px;
        height: 5px;
        background: #fff;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }

  .form-tips {
    font-size: 12px;
    color: #202020;
    width: 100%;
    margin-top: 8px;
    padding-left: 126px;
  }

  .receiveInfo-tips {
    height: 20px;

    .noFilled {
      display: flex;
      align-items: center;
      gap: 5px;
      color: #fe0000;
      justify-content: center;

      img {
        display: block;
        width: 14px;
        height: 14px;
      }
    }
  }

  .addInvoiceBtn {
    width: 370px;
    height: 50px;
    background: linear-gradient(to right, #fcbf00, #ffdb17);
    border-radius: 3px;
    font-size: 18px;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
    color: #333333;
    margin: 14px auto 0;
    cursor: pointer;
  }
}
.invoice-radio{
  margin-bottom: 0;
  font-weight: 400;
  display: flex;
  align-items: center;
  cursor: pointer;
  input{
    margin: 0 12px 0 0;
  }
}
/*单选框基本（未选中）的样式*/
.invoice-radio input[type="radio"]{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-size: 100% auto;
  box-sizing:border-box;
  border:solid 1px #fcc300;
}
/*单选按钮选中后增加的样式*/
.invoice-radio input[type="radio"]:checked:before {
  content: "";
  display: block;
  width: 9px;
  height: 9px;
  margin: 2px;
  border-radius: 10px;
  background-color: #fcc300;
}
.noData{
  width: 100%;
  height: 248px;
  text-align: center;
  padding-top: 50px;
}
</style>